<template>
  <v-app-bar
    class="header pl-10 pr-4"
    :elevation="0"
    :height="61"
  >
    <header-logo />
    <slot />
  </v-app-bar>
</template>

<script lang="ts">

import HeaderLogo from './HeaderLogo.vue';

import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Header',
  components: {
    HeaderLogo
  }
});

</script>

<style lang="scss" scoped>

.header {
  border-bottom: 1px solid rgba(0,0,0,.1);
}

</style>